import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Icon} from 'antd';
import {
  Container,
  TemplateConatiner,
  EmptySettingsDetails,
  LoaderContainer,
  TemplateWrapper,
} from './styles';
import EmptyElementsIllustration from '../../images/empty-elements.svg';
import DocumentTemplate from './DocumentTemplate';
import Loader from '../../components/Loader';
import CreateTemplateModal from '../../components/CreateNewTemplate/CreateTemplateModal';
import DeleteTemplateModal from '../../components/Modals/DeleteTemplateModal';

// app store context API
import { AppStoreContext } from '../../context/appStoreContext';
import { DOCUMENT_TEMPLATES_LIST } from './translationValues';
import { withTranslation } from 'react-i18next';
import { checkLockStatus } from '../../utils/services/complexDocumentsAPI';
import TemplateLockedModal from '../ComplexDocumentDesign/TemplateLockedModal';

const NAMESPACES = ['DOCUMENT_TEMPLATES_LIST'];

const DocTemplateSection = props => {
  const { tempCategories, languageList, t, forApproval } = props;
  const {
    loginVisible,
    userDetails,
    templatesList,
    totalTemplates,
    fetchingCategories,
  } = useContext(AppStoreContext);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [updateModalVisibility, setUpdateModalVisibility] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const [lockedBy, setLockedBy] = useState('');
  const [cloneTemplate, setCloneTemplate] = useState(undefined);
  const history = useHistory();

  useEffect(() => {
    if (
      loginVisible === false &&
      Boolean(selectedTemplate) &&
      Boolean(selectedTemplate.id) &&
      !Boolean(selectedAction)
    ) {
      history.push(`/design/${selectedTemplate.id}`);
    }
  }, [loginVisible, selectedTemplate, selectedAction, history]);

  const enableModalVisibility = async (actionType, template) => {
    const checkStatus = ['delete-template'].some(data => data === actionType);
    if (checkStatus) {
      actionType = (await checkTemplateStatus(template)) || actionType;
    }
    setUpdateModalVisibility(true);
    setSelectedAction(actionType);
    setSelectedTemplate(template);
  };

  const disableModalVisibility = () => {
    setUpdateModalVisibility(false);
    setSelectedAction(null);
    setSelectedTemplate(null);
  };

  const redirectToTemplate = template => {
    setCloneTemplate(undefined);
    const id = template?.id;
    if (!id) return;
    const waitingParam = forApproval ? '?waitingForApproval=true' : '';
    history.push(`/design/${id}${waitingParam}`);
  };

  const onSuccessDeletion = async () => {
    setUpdateModalVisibility(false);
    props.deteteTemplate(true);
  };

  const checkTemplateStatus = async template => {
    let payload = {
      resourceId: template.id,
      resourceType: 'document'
    }
    const templateStatus = await checkLockStatus(payload);
    if(templateStatus.statusCode === 741) {
      if(userDetails.id !== templateStatus.data.userId) {
        setLockedBy(templateStatus.data.userName);
        setSelectedAction('template-locked');
        setUpdateModalVisibility(true);
        return 'template-locked';
      }
    }
  };

  const renderBody = (categoriesTemp, templatesList) => {
    return (
      <React.Fragment>
        {templatesList.length > 0 && (
          <>
            <TemplateWrapper>
              {templatesList.map(templateObj => {
                return <DocumentTemplate
                  templateObj={templateObj}
                  categoriesTemp={categoriesTemp}
                  languageList={languageList}
                  redirectToTemplate={redirectToTemplate}
                  enableModalVisibility={enableModalVisibility}
                />;
              })}
            </TemplateWrapper>
          </>
        )}
      </React.Fragment>
    );
  };
  return (
    <Container>
      {fetchingCategories ? (
        <LoaderContainer>
          <Loader />
        </LoaderContainer>
      ) : (
        <TemplateConatiner>
          <>{totalTemplates === 0 ? '' : renderBody(tempCategories, templatesList)}</>
          {templatesList.length !== 0 && (
            <>
              {templatesList.length !== totalTemplates ? (
                <div className="addMore">
                  <Icon type="loading" />
                  {t(
                    DOCUMENT_TEMPLATES_LIST.LOADING_MORE.key,
                    DOCUMENT_TEMPLATES_LIST.LOADING_MORE.value,
                  )}
                </div>
              ) : (
                <div className="allData">
                  {t(
                    DOCUMENT_TEMPLATES_LIST.GOT_ALL_TEMPLATES_LIST.key,
                    DOCUMENT_TEMPLATES_LIST.GOT_ALL_TEMPLATES_LIST.value,
                  )}
                </div>
              )}
            </>
          )}

          {!fetchingCategories &&
            updateModalVisibility &&
            !loginVisible &&
            selectedAction &&
            (selectedAction === 'create-template' ? (
              <CreateTemplateModal
                visible={updateModalVisibility}
                onCancel={disableModalVisibility}
                onSucess={redirectToTemplate}
                categoryType="template"
              />
            ) : (
              ''
            ))}
          {!fetchingCategories &&
            updateModalVisibility &&
            !loginVisible &&
            selectedAction &&
            (selectedAction === 'delete-template' ? (
              <DeleteTemplateModal
                visible={updateModalVisibility}
                onCancel={disableModalVisibility}
                targetTemplate={selectedTemplate}
                categoryType="template"
                onSucess={onSuccessDeletion}
              />
            ) : (
              ''
            ))}
          {!fetchingCategories &&
            updateModalVisibility &&
            !loginVisible &&
            selectedAction &&
            selectedAction === 'template-locked' && (
              <TemplateLockedModal
                visible={selectedAction === 'template-locked'}
                onClose={disableModalVisibility}
                lockedByUser={lockedBy}
                deletion={true}
      />
            )}
          {cloneTemplate && (
            <CreateTemplateModal
              visible={true}
              onCancel={() => setCloneTemplate(false)}
              onSucess={redirectToTemplate}
              categoryType="template"
              type="cloneTemplate"
              template={cloneTemplate}
            />
          )}
        </TemplateConatiner>
      )}
      {!fetchingCategories && templatesList.length === 0 && (
        <EmptySettingsDetails>
          <div className="empty-illustration">
            <img src={EmptyElementsIllustration} alt="EmptyElementsIllustration" />
          </div>
          <div className="empty-txt" style={{ color: 'black' }}>
            <span>
              {t(
                DOCUMENT_TEMPLATES_LIST.EMPTY_TEMPLATES_LIST.key,
                DOCUMENT_TEMPLATES_LIST.EMPTY_TEMPLATES_LIST.value,
              )}
            </span>
            <span
              className="empty-links"
              onClick={() => enableModalVisibility('create-template', null)}
            >
              {t(
                DOCUMENT_TEMPLATES_LIST.CREATE_NEW_TEMPLATE_ACTION.key,
                DOCUMENT_TEMPLATES_LIST.CREATE_NEW_TEMPLATE_ACTION.value,
              )}
            </span>
            <span>
              {t(
                DOCUMENT_TEMPLATES_LIST.CREATE_NEW_TEMPLATE_INFO.key,
                DOCUMENT_TEMPLATES_LIST.CREATE_NEW_TEMPLATE_INFO.value,
              )}
            </span>
          </div>
        </EmptySettingsDetails>
      )}
    </Container>
  );
};

export default withTranslation(NAMESPACES)(DocTemplateSection);
